import { isAfter, isFuture } from "date-fns";

import { SessionPreview } from "@classview/shared-types";

export function hasSessionEnded(endDate: string) {
  return isAfter(new Date(), new Date(endDate));
}

export function findNextUpcomingSession(sessions: SessionPreview[]) {
  return (
    [...sessions]
      .filter((session) => isFuture(new Date(session.start)))
      .sort(
        (a, b) => new Date(a.start).getTime() - new Date(b.start).getTime(),
      )[0] || null
  );
}
